import { styled } from '@mui/material';

export const StyledChunkImageWrap = styled('div')({
	width: '100%',
	display: 'flex',
	justifyContent: 'center',
});

export const StyledChunkImage = styled('img')({
	display: 'block',
	height: 'auto',
	maxWidth: '100%',
	objectFit: 'contain',
	objectPosition: 'center',
	borderRadius: '16px',
});
